import React from "react";
import DfiBotDashboard from "./DfiBotDashboard";

// ARJUNA theme — Gold / Amber on deep warm-amber midnight (the champion, warrior gold)
const ARJUNA_THEME = {
    name: "gold",
    bg: "#140d04",
    hex: "#d4af37",
    hexHi: "#f0d060",
    text: "text-amber-200",
    textSoft: "text-amber-300",
    textSoft2: "text-amber-300/80",
    textSoft3: "text-amber-300/70",
    border: "border-amber-300/30",
    borderSoft: "border-amber-300/40",
    borderDim: "border-amber-300/20",
    bgGlow: "bg-amber-300/5",
    divide: "divide-amber-300/10",
    glow: "drop-shadow-[0_0_30px_rgba(212,175,55,0.5)]",
    bar: "bg-amber-300",
    hairline: "bg-amber-300/40",
    gridLine: "rgba(212,175,55,0.1)",
    accentDot: "bg-amber-300",
};

const arjuna = {
    name: "ARJUNA",
    tagline: "Active Growth · The disciplined archer's spot engine.",
    subTitle: "Seven capital layers · live on Bybit mainnet · copy-trade enabled · $100K institutional baseline",
    status: "LIVE · MAINNET",
    statusTone: "text-emerald-400 border-emerald-400/40 bg-emerald-400/5",
    theme: ARJUNA_THEME,
    baseCapital: 100000,
    annualApy: "+179%",
    monthlyApy: "14.74%",
    periodReturn: 0.1965, // 40-day live
    copyTrading: {
        followerAum: "8,473,200",
        followers: 23,
        signals24h: 142,
        latency: 84,
    },
    kpis: [
        { value: "+179%",   label: "Annualized Return", sub: "40-day live tranche conversion" },
        { value: "+19.65%", label: "40-Day Return",     sub: "Aug 13 → Sep 22, 2026" },
        { value: "+$19,650", label: "Lifetime P&L",     sub: "realised · $100K baseline" },
        { value: "0.00%",   label: "Max Drawdown",      sub: "live · lifetime" },
        { value: "45-80%",  label: "Target Net APY",    sub: "institutional allocation band" },
    ],
    streams: [
        {
            title: "L1 · Funding Arbitrage",
            rate: "primary engine",
            alloc: "~35% · $35,000",
            detail:
                "Spot-long + perp-short pairs harvesting funding premium every 4 hours across Tier-1 venues.",
        },
        {
            title: "L2 · Wyckoff Grid Trading",
            rate: "range harvest",
            alloc: "~25% · $25,000",
            detail:
                "Base-asset grid pre-stocked for two-way limit orders. Pure range extraction, zero chase.",
        },
        {
            title: "L3 · USDC Flexible Yield",
            rate: "~4.5% APR floor",
            alloc: "~10% · $10,000",
            detail:
                "Bybit Earn flexible savings on idle margin. Non-committed yield base.",
        },
        {
            title: "L4 · Institutional stETH",
            rate: "~4% APR",
            alloc: "~10% · $10,000",
            detail:
                "ETH staking via Bybit institutional and Lido. Compounded weekly.",
        },
        {
            title: "L5 · Dormant Volatility",
            rate: "regime-gated",
            alloc: "~10% · $10,000",
            detail:
                "Dormant USDC reserve · activates only on explicit volatility-regime signal.",
        },
        {
            title: "L6 · LP + L7 · BEAR-Gated",
            rate: "conditional",
            alloc: "~10% · $10,000",
            detail:
                "Liquidity provision layer + BEAR-regime-gated hedge layer that activates on signal.",
        },
    ],
    notes: [
        "Live tranche: $100,000 mainnet seed · currently $119,650 equity · +19.65% in 40 days · +179% annualized.",
        "Zero kill-switch fires · zero reconciliation discrepancies · daily blotter audit vs exchange statements.",
        "Hard circuit breakers: exchange solvency flags, basis blow-outs, operator-side kill switch, delta drift > 3%.",
        "Capital segregated into named sub-accounts per allocator · operator holds trade-only API keys.",
    ],
};

export default function DfiArjuna() {
    return <DfiBotDashboard bot={arjuna} />;
}
